<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-row :gutter="10" style="margin: 1rem 0">
          <CommonExcel ref="CommonExcelRef2" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
          <clear-cache-apply />
        </el-row>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%" height="600">
              <el-table-column label="序号" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template slot-scope="{row,$index}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                  <el-button type="success" size="mini" @click="handleCopy(row)">拷贝</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog :show-close="false" :before-close="handleClose" title="提示" :visible.sync="dialog" width="70%">
        <el-table :key="tableKey" size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <template v-if="type==1">
            <el-table-column prop="start" label="关卡">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.start" placeholder="关卡" />
              </template>
            </el-table-column>
            <el-table-column prop="v1" label="权重1">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.v1" placeholder="权重1" />
              </template>
            </el-table-column>
            <el-table-column prop="v2" label="权重2">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.v2" placeholder="权重2" />
              </template>
            </el-table-column>
            <el-table-column prop="v3" label="权重3">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.v3" placeholder="权重3" />
              </template>
            </el-table-column>
            <el-table-column prop="v4" label="权重4">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.v4" placeholder="权重4" />
              </template>
            </el-table-column>
            <el-table-column prop="prize1" label="奖励1">
              <template slot-scope="scope">
                <Reward :value="scope.row.prize1" />
              </template>
            </el-table-column>
            <el-table-column prop="prize2" label="奖励2">
              <template slot-scope="scope">
                <Reward :value="scope.row.prize2" />
              </template>
            </el-table-column>
            <el-table-column prop="prize3" label="奖励3">
              <template slot-scope="scope">
                <Reward :value="scope.row.prize3" />
              </template>
            </el-table-column>
            <el-table-column prop="prize4" label="奖励4">
              <template slot-scope="scope">
                <Reward :value="scope.row.prize4" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type==2">
            <el-table-column prop="ri" label="阶段">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.ri" placeholder="关卡" />
              </template>
            </el-table-column>
            <el-table-column prop="riCe" label="系数">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.riCe" placeholder="系数" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type==3">
            <el-table-column prop="stage" label="关卡">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.stage" placeholder="关卡" />
              </template>
            </el-table-column>
            <el-table-column prop="stageCe" label="系数">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.stageCe" placeholder="系数" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type==4">
            <el-table-column prop="stage" label="关卡">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.stage" placeholder="关卡" />
              </template>
            </el-table-column>
            <el-table-column prop="spins" label="体力">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.spins" placeholder="体力" />
              </template>
            </el-table-column>
            <el-table-column prop="price" label="价格" align="center">
              <Price :limit-type="limitType" />
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button size="small" type="primary" @click="addRewardDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import Price from '@/components/Price/index.vue'

export default {
  name: 'SignInAux',
  components: { Price, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      tableKey: 0,
      limitType: [2],
      loading: false,
      dialog: false,
      diaLogList: [],
      list: [],
      type: 1,
      typeArr: { 1: '奖励配置', 2: '复活间隔配置', 3: '关卡修正系数', 4: '复活礼包配置' },
      curClass: 'easter_egg'
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    openDialog(config) {
      this.tableKey++
      this.diaLogList = config
      this.dialog = true
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id != 0) {
          delActAuxiliary({ idList: [id] })
        }
        this.list[this.type].splice(index, 1)
      })
    },
    handleCopy(row) {
      const _row = Object.assign({}, row)
      _row.id = 0
      this.list[this.type].push(_row)
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name == sheet) {
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      actionActAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      fileName = this.typeArr[type]
      let tranTitle = {}
      switch (this.type) {
        case 1:
          tranTitle = {
            start: '关卡',
            // spinCe: '体力参数',
            riCe: '复活参数',
            // stageCe: '修正参数',
            v1: '权重1',
            v2: '权重2',
            v3: '权重3',
            v4: '权重4',
            prize1: { name: '奖励1', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }},
            prize2: { name: '奖励2', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }},
            prize3: { name: '奖励3', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }},
            prize4: { name: '奖励4', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}
          }
          break

        case 2:
          tranTitle = {
            ri: '关卡',
            riCe: '系数'
          }
          break
        case 3:
          tranTitle = {
            stage: '关卡',
            stageCe: '系数'
          }
          break
        case 4:
          tranTitle = {
            stage: '关卡',
            spins: '体力',
            mtype: '类型',
            sku: '库存',
            bet: '倍数',
            price: '价格'
          }
          break
      }
      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef2.makeExcelData(dataArr[i], tranTitle)
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addRewardDialogList(index) {
      switch (this.type) {
        case 1:
          this.diaLogList.push({ start: 1, spinCe: 0, v1: 1, v2: 1, v3: 1, v4: 1, prize1: [], prize2: [], prize3: [], prize4: [] })
          break

        case 2:
          this.diaLogList.push({ ri: 1, riCe: 0 })
          break

        case 3:
          this.diaLogList.push({ stage: 1, stageCe: 0 })
          break
        case 4:
          this.diaLogList.push({ stage: 1, spins: 0 })
          break
      }
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    }
  }
}
</script>

